<template>
    <div class="home-page">
		<Header></Header>
		<div class="content mt100 por">
      <router-link :to="{path:'/myAccount'}">
        <div class="info flex-evenly disflex">
          <div class="">
            <div class="name crfff mt50 ovhidden">{{$t('hey')}}{{username}}</div>
            <div class="fs33 crfff">{{$t('homeTips1')}}<img class="ml10" src="../../static/images/jirou.png"></div>
          </div>
          <img class="img" src="static/images/accout-img.png" />
          </div>
      </router-link>
			<div class="home1 flex-center">
				<div class="">
					<div class="list-title flex-evenly ac flex">
						<div :class="{'active':isShow==item.id}" v-for="(item,index) in info.grades" @click="getListTitle(item.id)">
              {{item.name}}
            </div>
					</div>
					<div class="list-content">
            <div class="tips mt50 ml10">{{$t('homeTips2')}}</div>
            <div class="list-c mt20 flex">
              <div class="list-li" v-for="(item,index) in subject" @click="getList(item.id,item.name)">
                <img :src="item.image">
                <div class="li-title ac">
                  {{item.name}}
                </div>
              </div>
            </div>
					</div>
				</div>
			</div>
      <div class="">
        <img class="w100" src="../../static/images/home-img.jpg" />
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {

    return {
			info:{},
			msisdn:'',
      isShow:false,
      dataPopup:null,
      username:'',
      subject:[]
		}
    },
    watch: {

    },
    computed:{
    },
    mounted() {
		let that = this;
    },
    created(){
      if(this.$route.query.msisdn){
        this.msisdn = this.$route.query.msisdn
        if(!localStorage.getItem('token')){
          this.getapiPopup()
        }
      }
      if(localStorage.getItem('username')) this.username = localStorage.getItem('username')
      this.getHome();
    },
    methods: {
      getListTitle(id){
        let that = this
        that.isShow = id
        let data = {
          grade_id:id
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/index/subject',data,r =>{
          that.$parent.returnCode(r,function(){
            that.subject = r.data
            that.$parent.loadModal(false);
          });
        })
      },
      getItem() {
		    if (!localStorage.getItem('setTime_v1') || (localStorage.getItem('setTime_v1') &&
		        Date.parse(new Date()) - localStorage.getItem('setTime_v1') >= 86400000)) {//86400000 24h
		        localStorage.removeItem('setTime_v1');
		        localStorage.setItem('setTime_v1', Date.parse(new Date()));
		        this.getapiPopup();
		    }
		  },
      getapiPopup(){
        let that = this
        let data = {
          mobile:that.msisdn
        }
        that.$api.post('/api/user/fast_login',data,r =>{
        	that.$parent.returnCode(r,function(){
            localStorage.setItem('token',r.data.userinfo.token)
            localStorage.setItem('mobile',r.data.userinfo.mobile)
            localStorage.setItem('username',r.data.userinfo.nickname)
            that.username = localStorage.getItem('username')
            //that.$utils.alertText(r.msg,80);
        	})
        })

      },
      getHome(){
        let that =this;
        that.$parent.loadModal(true);
        that.$api.post('/api/index',null,r =>{
          that.$parent.returnCode(r,function(){
            that.info = r.data
            that.isShow = that.info.grades[0].id
            that.subject = that.info.subject
            that.$parent.loadModal(false);
          });
        })
      },
      getList(id,name){
        this.$router.push({path:'/list',query: {id:id,name:name}})
      }
	}
}
</script>
<style>
  .modal-content2{text-align:center;position:absolute;top:50%;left:50%;margin-top:-10px;border-radius:8px;margin-left: -45%;width: 90%;}
  .modal-content2 img{border-radius:20px;width:100%;}
  .close{background: rgb(255 255 255 / 20%);
    color: #fff;
    width: 80px;
    height: 80px;
    font-size: 47px;
    margin: 30px auto 0;
    border-radius: 100px;}
</style>



// WEBPACK FOOTER //
// src/page/index.vue